import Lottie from "lottie-react";
import { Button } from "primereact/button";
import loadingAnim from "../../../../../../assets/animations/pleasewait.json";
import successAnim from "../../../../../../assets/animations/success.json";
import failAnim from "../../../../../../assets/animations/fail.json";
import { StepBody, StepHeader, StepNav } from "../Hikvision/HikvisionWizardParts";
import classes from "../../RuleWizard/RuleWizard.module.css";

// status: "linking" | "success" | "failed"
// note - optional explanation shown on success, e.g. what was skipped when the connection test was skipped
const WizardStepCamectResult = ({ status, failReason, onBack, onClose, successTitle = "Camect linked successfully!", note }) => {
    if (status === "linking") {
        return (
            <>
                <StepHeader title="Linking Camect" subtitle="Please wait..." />
                <StepBody style={{ alignItems: "center", justifyContent: "center" }}>
                    <Lottie animationData={loadingAnim} loop style={{ width: 260, height: 260 }} />
                </StepBody>
                <StepNav onClose={onClose} />
            </>
        );
    }

    if (status === "success") {
        return (
            <>
                <StepHeader title={successTitle} />
                <StepBody style={{ alignItems: "center", justifyContent: "center" }}>
                    <Lottie animationData={successAnim} loop={false} style={{ width: 220, height: 220 }} />
                    {note && <p style={{ color: "#6e6e6e", textAlign: "center", maxWidth: "420px" }}>{note}</p>}
                </StepBody>
                <div className={classes.navRow}>
                    <span />
                    <Button label="Close" icon="pi pi-times" severity="secondary" onClick={onClose} />
                </div>
            </>
        );
    }

    return (
        <>
            <StepHeader title="Failed to link Camect" subtitle="Go back to check your selections and try again" />
            <StepBody style={{ alignItems: "center", justifyContent: "center" }}>
                <Lottie animationData={failAnim} loop={false} style={{ width: 150, height: 150 }} />
                <p style={{ color: "#6e6e6e", textAlign: "center", maxWidth: "420px" }}>{failReason}</p>
            </StepBody>
            <StepNav onBack={onBack} onClose={onClose} />
        </>
    );
};

export default WizardStepCamectResult;
